import { useDispatch, useSelector } from 'react-redux'
import { RootState } from '../redux/store'
import { getConfigurationActionAsync } from '../redux/actions/configurationActions'

export const useConfiguration = () => {
  const { configurationState } = useSelector(
    (state: RootState) => state.configuration
  )
  const dispatch = useDispatch()

  const getConfiguration = () => {
    dispatch(getConfigurationActionAsync())
  }

  return { configurationState, getConfiguration }
}
